import type { PanelType } from '../../../model/panel';
import type { State } from '../../types';

export const getPanelType = (state: State): PanelType => state.ui.panel.panelType;
